import { ROUTES } from "@/constants/routes";
import { useMatch } from "react-router-dom";

/** Active chat from the main chat detail route (not canvas session pane). */
export function useActiveChatFlowSessionId(): string | null {
  const match = useMatch(ROUTES.CHAT.DETAIL);
  return match?.params?.flowSessionId ?? null;
}
